<template>
  <span>
    <div class="banner p1-3 mt-3">PRIVACY POLICY NOTICE</div>
    <div class="container text-center">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10">
          <p>
            The security and privacy of customer information is a priority of
            the PGP Title Family of Companies* (“PGP”). Under federal and some
            state laws, you have a right to know how we will collect, share and
            protect the personal information you provide to us. Please read this
            notice carefully to understand our policy and practices concerning
            your personal information.
          </p>
          <h2>Information We Collect</h2>
          <ul>
            <li>
              Information we receive on applications, contracts or other forms,
              whether received in writing, in person, by telephone or any other
              means. The information may include your name, address, telephone
              number, birthdate, Social Security number, driver’s license
              number, income, transaction history, purchase history, and account
              balances, among other information provided.
            </li>
            <li>
              Information about your transactions that we obtain for our files,
              or from our affiliates or others (such as the identity of the real
              property you are buying or financing).
            </li>
            <li>Information we receive from a consumer-reporting agency.</li>
            <li>
              Information that we receive from others involved in your
              transaction, such as the lender, attorney or real estate broker
              (such as appraisals, credit reports, land surveys, escrow
              balances, and sometimes bank account numbers).
            </li>
            <li>
              Information about your computer and browsing behavior, like the
              type of browser you use, or your IP address. We may collect this
              information, or vendors we hire may collect it.
            </li>
          </ul>
          <h2>How We Use Your Information</h2>
          <p>
            PGP uses your information for legitimate business purposes,
            including to process your transactions, to offer products and
            services to you, to respond to your inquiries and to comply with
            court orders and requests from government and law enforcement
            agencies. We may also store your personal information for a period
            of time after your transaction is complete. Stored information is
            used only for quality control, customer analysis, to respond to
            customer requests or issues, or to respond to requests for
            information from government and law enforcement agencies.
          </p>
          <h2>Sharing Your Information</h2>
          <p>
            The privacy laws permit some sharing without your approval. We may
            share with affiliates and with nonaffiliates in order to carry out
            and service your transaction. We may share with affiliate and
            nonaffiliated third parties to protect against fraud or unauthorized
            transactions, for institutional risk control, in response to
            requests for information from government and law enforcement
            agencies, or as permitted by law. Information about your
            creditworthiness is shared only to facilitate your transaction or
            for another purpose permitted by law. PGP does not share your
            information with affiliates or nonaffiliates for marketing purposes.
          </p>
          <h2>How We Protect Your Information</h2>
          <p>
            PGP strives to ensure that your information is protected from
            unauthorized access and use. We restrict access to your personal
            information to those employees who need to know that information in
            order to provide products or services to you. We maintain physical
            security of our files and offices. We also use electronic and
            procedural safeguards that comply with federal regulations to guard
            your personal information. We train and reinforce the privacy policy
            with all PGP employees to help ensure that your information will be
            protected in accordance with law and this policy.
          </p>
          <h2>Former Customers</h2>
          <p>
            After you are no longer an active PGP customer, we will continue to
            treat information you have provided as if you were still a customer.
          </p>
          <h2>Information Obtained Through Our Website</h2>
          <p>
            In general, you can visit the PGP website without disclosing your
            identity or personal information about yourself. We only collect
            information about your computer, such as your IP address or the type
            of browser you use when you visit our website. Information collected
            about your computer and browser history is used to monitor the
            number of visits to our website, pages viewed and similar
            information to help us determine effectiveness of the site and to
            improve content. You may choose to provide personal information to
            us through our website in order to request information, products or
            services, or to submit a complaint or inquiry. Any information
            provided via our website will be used only in accordance with the
            policies outlined above.
          </p>
          <h2>External Links</h2>
          <p>
            PGP’s website and its affiliates’ sites may contain links to
            external websites. These sites are not controlled by PGP and/or its
            affiliates, and PGP is not responsible for the content or privacy
            practices utilized on those sites.
          </p>
          <h2>Cookies</h2>
          <p>
            PGP’s website, www.pgptitle.com, may use cookie technology to
            measure site activity and to better serve you. In order for PGP to
            consistently and securely identify you during your session, we
            require cookies to be enabled for our site.
          </p>
          <h2>Questions</h2>
          <p>
            For questions about this notice, contact PGP via telephone
            877-799-2582 or by email
            <a href="mailto:info@pulte.com">info@pulte.com</a>
          </p>
          <table>
            <tbody>
              <tr>
                <td colspan="2" style="text-align: left !important">
                  *The PGP Title Family of Companies consists of the following
                  entities:
                </td>
              </tr>
              <tr>
                <td colspan="2">&nbsp;</td>
              </tr>
              <tr class="text-align-center">
                <td>PGP Title, Inc.</td>
                <td>PGP Title, LLC</td>
              </tr>
              <tr class="text-align-center">
                <td>PGP Title, Inc. dba PGP Closing Services</td>
                <td>Premier Land Title Insurance Company</td>
              </tr>
              <tr>
                <td>PGP Title of Florida, Inc. dba PGP Title</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </span>
</template>

<style scoped>
div {
  font-family: Source Sans Pro, Arial, Helvetica, sans-serif;
}

h2 {
  font-size: 30px;
  font-weight: bold;
  text-align: left;
  margin: 0 0 8px;
}

p {
  text-align: left;
  font-size: 16px;
  color: #202a2f;
  margin: 0 0 16px;
  font-family: Source Sans Pro, Arial, Helvetica, sans-serif;
}

table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

td {
  overflow-wrap: anywhere;
  word-break: break-word;
  text-align: center;
  vertical-align: top;
  padding-right: 0.5rem;
  font-size: 14px;
}

img,
table {
  max-width: 100%;
}
</style>

<script setup></script>
